import React, { Component } from 'react';
import validate from 'validate.js';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Button, TextField } from '@material-ui/core';
import { CustomSnackbar, Link } from '..';
const axios = require('axios');
import history from '../../history';
import { useStyles } from './styles.js';

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
  },
};

class ForgotPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        email: '',
      },
      touched: {},
      errors: {},
      isValid: false,
      isSubmitted: false,
      openSnackbar: false,
      forgotPasswordMessageType: '',
      forgotPasswordMessage: '',
    };
  }

  componentDidMount() {
    const errors = validate(this.state.values, schema);
    this.setState({ isValid: errors ? false : true, errors: errors || {} });
  }

  handleChange = event => {
    event.persist();
    var { values, touched } = this.state;
    values[event.target.name] =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    touched[event.target.name] = true;

    this.setState({ values: values, touched: touched }, () => {
      const errors = validate(this.state.values, schema);
      this.setState({ isValid: errors ? false : true, errors: errors || {} });
    });
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isSubmitted: true });
    axios
      .post('/forgot-password', {
        email: String(this.state.values.email).toLowerCase(),
      })
      .then(response => {
        var data = response.data;
        if (data.code == 'Success') {
          this.setState({
            openSnackbar: true,
            forgotPasswordMessageType: 'Success',
            forgotPasswordMessage: data.message,
          });
          setTimeout(() => {
            history.push('/admin/login');
          }, 2000);
        } else {
          this.setState({
            openSnackbar: true,
            forgotPasswordMessageType: 'Error',
            forgotPasswordMessage: data.message,
            isSubmitted: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          openSnackbar: true,
          forgotPasswordMessageType: 'Error',
          forgotPasswordMessage: 'Unexpected Error.',
          isSubmitted: false,
        });
      });
  };

  handleSnackbarClose = () => {
    this.setState({ openSnackbar: false });
  };

  render() {
    const hasError = field => {
      return this.state.touched[field] && this.state.errors[field]
        ? true
        : false;
    };

    const { className, classes } = this.props;

    return (
      <form
        className={clsx(classes.root, className)}
        onSubmit={this.handleSubmit}
      >
        <div className={classes.fields}>
          <TextField
            error={hasError('email')}
            fullWidth
            helperText={hasError('email') ? this.state.errors.email[0] : null}
            label="Email address"
            name="email"
            onChange={this.handleChange}
            value={this.state.values.email || ''}
            variant="outlined"
          />
        </div>
        <div className={classes.loginLinkWrapper}>
          <Link to="/admin/login" className={classes.loginLink}>
            Back to Login
          </Link>
        </div>

        <div className={classes.submitButtonDiv}>
          <Button
            className={classes.submitButton}
            color="secondary"
            disabled={!this.state.isValid || this.state.isSubmitted}
            size="large"
            type="submit"
            variant="contained"
          >
            Submit
          </Button>
        </div>
        <CustomSnackbar
          onClose={this.handleSnackbarClose}
          open={this.state.openSnackbar}
          type={this.state.forgotPasswordMessageType}
          message={this.state.forgotPasswordMessage}
        />
      </form>
    );
  }
}

ForgotPasswordForm.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(ForgotPasswordForm);
